import PlaceholderPage from "../../../components/Placeholder/PlaceholderPage";

const ToDosPage = () => (
  <PlaceholderPage
    title="To Dos"
    description="Your vendor-management tasks will appear here."
  />
);

export default ToDosPage;
